import { render, staticRenderFns } from "./operate-role-modal.vue?vue&type=template&id=0af4c8ae&scoped=true"
import script from "./operate-role-modal.vue?vue&type=script&lang=js"
export * from "./operate-role-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4c8ae",
  null
  
)

export default component.exports